import axiosServicesOnboarding from "../../../services/axiosServicesOnboarding";
import api, { configDevUrl, formApi } from "../api";

const UsersModule = () => {
  return {
    ChangePin: function (data) {
      return api.post("identity/Agent/changepin", data);
    },

    //Agents
    SuperdealerAgents: function (data) {
      return api.get("identity/Superdealer/agents", data);
    },

    SingleSuperdealerAgents: function (data) {
      return api.get(`identity/Superdealer/agents/${data}?id=${data}`, data);
    },

    UpdateSuperdealerAgents: function (data) {
      return api.post(`identity/Superdealer/agents/updateagent`, data);
    },

    GetSuperdealerAgentsProducts: function (data) {
      return api.get(
        `identity/Superdealer/products/agent/${data}?agentId=${data}`,
        data
      );
    },

    //Resellers
    SuperdealerResellers: function (data) {
      return api.get("identity/Superdealer/reseller", data);
    },

    SingleSuperdealerResellers: function (data) {
      return api.get(`identity/Superdealer/reseller/${data}?id=${data}`, data);
    },

    UpdateSuperdealerReseller: function (data) {
      return api.post(`identity/Admin/superdealer/agents/update`, data);
    },

    GetSuperdealerResellerProducts: function (data) {
      return api.get(
        `identity/Superdealer/products/reseller/${data}?agentId=${data}`,
        data
      );
    },

    BulkUploadAgent: function ({ agentRole, fileData }) {
      console.log("dataaaa", { agentRole, fileData });
      return formApi.post(`identity/Agent/uploadagents/${agentRole}`, fileData);
    },

    AgentSearch: function (data) {
      return api.get(
        `identity/Agent/agents/search?EmailAddress=${data.email}&MobileNumber=${data.phone}`
      );
    },

    //products
    getProducts: function (data) {
      return api.get(`identity/Agent/products`);
    },

    // /Agent/reseller/onboardagent
    OnboardAgent: function (data) {
      return api.post("identity/Agent/reseller/onboardagent", data);
    },

    // EnableAction
    EnableAction: function (data) {
      const { AgentId, Type } = data;
      return api.post(
        `identity/Agent/downline/settings/activate?AgentId=${AgentId}&Activate=true&Type=${Type}`
      );
    },

    // DisableAction
    DisableAction: function (data) {
      const { AgentId, Type } = data;
      console.log("holy", data);
      return api.post(
        `identity/Agent/downline/settings/deactivate?AgentId=${AgentId}&Activate=false&Type=${Type}`
      );
    },

    // ActivateCustomers
    ActivateCustomers: function (data) {
      return api.post("identity/Admin/agents/activateuser", data);
    },

    // DeactivateCustomers
    DeactivateCustomers: function (data) {
      return api.post("identity/Admin/agents/deactivateuser", data);
    },

    // AddMoreProducts
    AddMoreProducts: function (data) {
      return api.post(
        "identity/Admin/superdealer/agents/products/create",
        data
      );
    },

    // Customerroducts
    CustomerProductsAgent: function (data) {
      // return api.get(`identity/ProductAdmin/products/agent/${data}`, data);
      return api.get(`identity/agent/downline/product/${data}`, data);
    },

    // Customerroducts
    CustomerProductsResseller: function (data) {
      // return api.get(`identity/ProductAdmin/products/reseller/${data}`, data);
      return api.get(`identity/agent/downline/product/${data}`, data);
    },

    // UpdateCustomerProducts
    UpdateCustomerProducts: function (data) {
      return api.post(`identity/Admin/superdealer/agent/status/update`, data);
    },

    // /Admin/superdealer/agents/product/commission/update
    UpdateCustomerCommission: function (data) {
      return api.post(
        `identity/Admin/superdealer/agents/product/commission/update`,
        data
      );
    },

    // UpdateCommission
    UpdateCommission: function (data) {
      return api.post(`/identity/Agent/product/bulkupdate`, data);
    },

    //list of customers
    ListCustomers: function (data) {
      //console.log("tttttttt", data);
      return api.get(
        `identity/Agent/downlines?PageSize=${data.pageSize}&CurrentPage=${data.currentPage}&SearchText=${data.keyword}`
      );
    },

    // flexmonie ***********************************
    // https://onboarding-dev.flexmonie.com/v1/api/Customer/validate-customer
    ValidateCustomer: function (data) {
      return axiosServicesOnboarding.post(`Customer/validate-customer`, data);
    },

    // https://onboarding-dev.flexmonie.com/v1/axiosServicesOnboarding/Agent
    OnboarDownline: function (data) {
      return axiosServicesOnboarding.post("/Agent", data);
    },

    CurrentUser: function (data) {
      return axiosServicesOnboarding.get("Auth/sessiondetails");
    },

    GetAllDownlines: function (data) {
      let url = `Agent?PageSize=${data.pageSize}&Page=${data.currentPage}`;

      if (data.keyword) {
        url += `&SearchText=${encodeURIComponent(data.keyword)}`;
      }

      return axiosServicesOnboarding.get(url);
    },

    GetDownlineById: function (data) {
      return axiosServicesOnboarding.get(`Agent/${data}`);
    },

    GetDownlineProduct: function (id) {
      return configDevUrl.get(
          `DownlineProduct/DownlineProducts?walletId=${id}`
      );
    },

    GetDownlineByIdAggregator: function (data) {
      return axiosServicesOnboarding.get(`Aggregator/${data}`);
    },

    GetAllAggregators: function (data) {
      let url = `Aggregator?PageSize=${data.pageSize}&Page=${data.currentPage}`;

      if (data.keyword) {
        url += `&SearchText=${encodeURIComponent(data.keyword)}`;
      }

      return axiosServicesOnboarding.get(url);
    },

  };
};

export const UsersService = {
  usersModule: UsersModule,
};
